<script lang="ts">
	import Logo from "../Logo.svelte";
	import { onMount, tick } from "svelte";
	import { dldl, goto, yyyy } from "../store.svelte";
	import { toast } from "../lib/toast.svelte.ts";
	import getlivewires from "../extras/getlivewires.svelte";
	import { fly } from "svelte/transition";
	import { jwtDecode } from "jwt-decode";

	const url: string = yyyy.uri.api;
	let ready: boolean = false;
	let inemail: string;
	let inpass: string;
	let shake: boolean = false;
	let isdanger: boolean = false;
	let forgotPassword: boolean = false;
	let emailbox: HTMLInputElement;
	let passbox: HTMLInputElement;
	let waiting: boolean = false;
	let cancelBox = () => {
		goto("/");
	};

	let doForgottenPassword = async (e: MouseEvent) => {
		//console.log("forgotPassword");

		e.preventDefault();
		if (forgotPassword) {
			if (typeof inemail === "undefined" || inemail === null) {
				shake = true;
				isdanger = true;
			} else {
				waiting = true;
				let _hdrs = { "Content-Type": "application/json" };
				let _body = JSON.stringify({ email: inemail });
				let fetchopts = { method: "post", body: _body, headers: _hdrs };
				const response = await fetch(`${url}/rpc/forgot`, fetchopts);
				if (response.ok) {
					//console.log("forgotpassword interaction");
					toast.success("Check your email for a link to reset your password");
					goto("/");
				} else {
					toast.error("An error occured. Please try again");
					waiting = false;
				}
			}
		} else {
			forgotPassword = true;
		}

		setTimeout(() => {
			shake = false;
			yyyy.logo.usage = "logo";
		}, 750);
	};

	let handleSignIn = async () => {
		yyyy.logo.usage = "wait";
		let _hdrs = { "Content-Type": "application/json" };
		let _body = JSON.stringify({ email: inemail, pass: inpass });
		let fetchopts = { method: "post", body: _body, headers: _hdrs };
		const response = await fetch(`${url}/rpc/signin`, fetchopts);
		if (response.ok) {
			yyyy.sesh.logtoken = await response.json();
			yyyy.sesh.tokeninfo = jwtDecode(yyyy.sesh.logtoken.token);
			yyyy.ui.centered = false;
			// Fetch livewires right after successful login
			await getlivewires();
			goto("/livewires");
		} else {
			shake = true;
			isdanger = true;
			inpass = "";
		}
		setTimeout(() => {
			shake = false;
			yyyy.logo.usage = "logo";
		}, 750);
	};

	let enterPressed = (event: KeyboardEvent) => {
		const target = event.target as HTMLInputElement;

		if (event.key === "Enter" && target.id === "email" && inemail !== undefined) {
			event.preventDefault(); // Prevent default form submission
			passbox.focus();
		}
		if (
			event.key === "Enter" &&
			target.id === "password" &&
			inpass !== undefined
		) {
			event.preventDefault(); // Prevent default form submission
			handleSignIn();
		}
	};

	onMount(() => {
		dldl("SignIn.svelte", "SignIn mounted");
		setTimeout(async () => {
			ready = true;
			yyyy.logo.usage = "logo";
			await tick(); // Wait until the DOM has been updated
			emailbox.focus();
		}, 250);
	});
</script>

<div class="column is-one-quarter porridge">
	{#if ready}
		<div class="card lvwr-card" class:shake>
			<div
				transition:fly|local={{ y: -200 }}
				class="card-content lvwr-card-content"
			>
				<h1 class="title thin lvwr-title">Livewire</h1>
				<h2 class="subtitle lvwr-subtitle">Power Delivery Modelling in the Cloud by</h2>
				<div class="content">
					<Logo usage={yyyy.logo.usage} interact={false} />
				</div>
				<div class="content">
					<div class="field">
						<label class="label" for="email">email</label>
						<div class="control">
							<input
								id="email"
								class="input"
								class:is-danger={isdanger}
								type="email"
								placeholder="email address"
								bind:value={inemail}
								bind:this={emailbox}
								onkeypress={enterPressed}
							/>
						</div>
						<p class="help is-success"></p>
					</div>
					{#if !forgotPassword}
						<div class="field">
							<a
								href="/#"
								class="password-changer"
								onclick={doForgottenPassword}
								tabindex="-1">Forgot password?</a
							>
							<label class="label" for="password">password</label>
							<div class="control">
								<input
									id="password"
									class="input"
									class:is-danger={isdanger}
									type="password"
									placeholder="password"
									bind:value={inpass}
									bind:this={passbox}
									onkeypress={enterPressed}
								/>
							</div>
							<p class="help is-success"></p>
						</div>
					{:else}
						Enter your email address and we will send a link to securely change your
						password
					{/if}
				</div>
			</div>
			<footer transition:fly|local={{ y: 200 }} class="card-footer">
				<div class="card-footer-item sign-in-cancel-footer">
					<button
						onclick={cancelBox}
						tabindex="-1"
						class="button lvwr-toggle-cancel">Cancel</button
					>
					{#if !forgotPassword}
						<button
							onclick={handleSignIn}
							disabled={!inemail || !inpass}
							class="button lvwr-toggle">Sign-In</button
						>
					{:else}
						<button
							transition:fly|local={{ y: 200 }}
							onclick={doForgottenPassword}
							disabled={!inemail}
							class:is-loading={waiting}
							class="button lvwr-toggle">Request link</button
						>
					{/if}
				</div>
			</footer>
		</div>
	{/if}
</div>

<style>
	.porridge {
		position: fixed;
		top: 0;
		bottom: 0;
		left: 0;
		right: 0;
		margin: auto;
		height: fit-content;
		z-index: 5;
	}

	input {
		cursor: #ff3e00;
	}

	.lvwr-card-content {
		height: 410px;
	}

	.shake {
		animation: shake 0.75s;
		animation-iteration-count: 2s;
	}

	@keyframes shake {
		0% {
			transform: translate(1px, 1px) rotate(0deg);
		}
		10% {
			transform: translate(-1px, -2px) rotate(-5deg);
		}
		20% {
			transform: translate(-3px, 0px) rotate(5deg);
		}
		30% {
			transform: translate(3px, 2px) rotate(0deg);
		}
		40% {
			transform: translate(1px, -1px) rotate(3deg);
		}
		50% {
			transform: translate(-1px, 2px) rotate(-3deg);
		}
		60% {
			transform: translate(-3px, 1px) rotate(0deg);
		}
		70% {
			transform: translate(3px, 1px) rotate(-2deg);
		}
		80% {
			transform: translate(-1px, -1px) rotate(2deg);
		}
		90% {
			transform: translate(1px, 2px) rotate(0deg);
		}
		100% {
			transform: translate(1px, -2px) rotate(0deg);
		}
	}
</style>
